export const MAX_SUPPORT_CASE_SUBJECT_LENGTH = 255;
export const MAX_SUPPORT_CASE_DESCRIPTION_LENGTH = 32000;
